import React, { useState, FC, useEffect } from 'react';
//components
import toast from '../../../../components/Toast/dispatch';
import Select from "../../components/generics/Select";
import { Column, Row } from "components/Layout/Grid";
import { Visibility } from 'components/Visibility';
import { Button } from 'components/Button';
import Text from 'components/Text';
//services
import DomainSettingService from 'services/domainSetting.service';
import QuoteServices from '../../../../services/quote.service';
//utils
import { IsNullOrEmpty } from 'utils/StringNullOrEmpty';
//others
import { INotParticipateObservation } from '../../../../models/portalModels/ItemObservation';
import { IOptionDropdownProps } from './interface';

import './styles.scss';
import { NotParticipateStatus } from 'components/Table/interface';

const ModalNotParticipate: FC<any> = ({
    handleCloseModal,
    quoteDetail,
    setNotParticipateStatus,
    setIsActiveNotParticipate,
    setSupplierStatus,
    setSuccessModal,
    setNotParticipateStatusLabel,
    setOtherOption
}: any) => {
    const [selectValue, setSelectValue] = useState<string>(quoteDetail.NotParticipateStatus);
    const [selectLabel, setSelectLabel] = useState<string>("");

    const [notParticipateStatusOptions, setNotParticipateStatusOptions] = useState<Array<IOptionDropdownProps>>();
    const [notParticipateFieldText, setNotParticipateFieldText] = useState<string>("");

    const _domainSettingService = new DomainSettingService();

    const handleSelectChange = (event: any) => {
        setSelectValue(event.target.value);
        setSelectLabel(event.target.options[event.target.selectedIndex].text);
    };

    const handleNotParticipateText = (event: any) => {
        setNotParticipateFieldText(event.target.value);
    };

    const handleFinishButton = () => {
        if ((selectValue !== NotParticipateStatus.OTHER && !IsNullOrEmpty(selectValue)) ||
            (selectValue === NotParticipateStatus.OTHER && notParticipateFieldText.length > 0)) {
            return true;
        } else {
            return false;
        }
    };

    const getNotParticipateOptions = async () => {
        const response = await _domainSettingService.get(undefined, undefined, undefined, {
            and: [
                { identifier: { eq: 'NotParticipateOptions' } },
                { enabled: { eq: true } },
            ],
        });

        const { data } = response;

        const parseOptionValue: IOptionDropdownProps[] = JSON.parse(data[0].value);

        setNotParticipateStatusOptions(parseOptionValue);
    };

    const saveFieldNotParticipateStatus = async () => {
        const notParticipateModel: INotParticipateObservation = {
            quotationId: quoteDetail.quoteId,
            notParticipateType: selectValue,
            notParticipateMessage: notParticipateFieldText,
        };
        handleCloseModal();

        await new QuoteServices().saveFieldNotParticipateStatus(
            notParticipateModel
        )
            .then(() => {
                setNotParticipateStatus(selectValue);
                setIsActiveNotParticipate(false);
                setSupplierStatus("Não participar");
                setSuccessModal(true);
                setNotParticipateStatusLabel(selectLabel);
            })
            .catch((error) => {
                toast.error(`Não foi possível salvar o status de não participado.
                ${JSON.stringify(error?.response?.statusText)}`);
            });
    };

    setOtherOption(selectLabel === NotParticipateStatus.OTHER);

    useEffect(() => {
        getNotParticipateOptions();
    }, []);

    return (
        <>
            <div className='modalContent'>
                <Row className='mt-5'>
                    <Column>
                        <h4 className='text'>
                            Selecione o motivo para <span>não <br /> participar</span> desta cotação
                        </h4>
                    </Column>
                </Row>

                <Row className='mt-5'>
                    <Column>
                        <Select
                            defaultBlankValue="Selecione o motivo"
                            className='select'
                            onChange={(e: any) => handleSelectChange(e)}
                            options={notParticipateStatusOptions}
                        />
                    </Column>
                </Row>

                <Visibility visible={selectLabel === "Outro"}>
                    <Row className='other-option'>
                        <Text size={10} color={'#858585'}>Motivo de não participar:</Text>
                        <textarea
                            value={notParticipateFieldText}
                            onChange={(event: any) => handleNotParticipateText(event)}
                            name="notParticipateField"
                            placeholder='Descreva'
                        />
                    </Row>
                </Visibility>

                <Row className='buttonContainer'>
                    <Column>
                        <Button onClick={handleCloseModal} className='cancel'>Cancelar</Button>
                    </Column>
                    <Column>
                        {handleFinishButton() ?
                            <Button onClick={saveFieldNotParticipateStatus} className='finish'>Finalizar</Button>
                            :
                            <Button disabled={true} className='finish disableBtn'>Finalizar</Button>
                        }
                    </Column>
                </Row>
            </div>
        </>
    );
};
export default ModalNotParticipate;